module.exports = __webpack_public_path__ + "img/leaf2.3b1af9de.png";